import ViewBuildingItem from "components/ViewBuildingItem";
import { useNavigate } from "react-router";

export default function BuildingsCard({ buildings }) {

    const navigate = useNavigate();

    const handleClickDetail = (building_id) => {
        navigate(`/reservation/new/${building_id}`, {
            state: {
                from: '/'
            }
        });
    }

    return (
        <div className={`section mt-2 mb-2 ${buildings && buildings.length === 0 ? 'd-none' : ''}`}>
            <div className="card">
                <div className="card-body px-0 pb-0">
                    <h5 className="card-title px-3">Immobili da prenotare</h5>
                    <ul className="listview image-listview no-border mb-2 line-divider">
                        {!buildings && Array(3).fill(null).map((_,i) => <ViewBuildingItem key={i} isSkeleton />)}
                        {buildings && buildings.map(building => {
                            return (
                                <ViewBuildingItem 
                                    key={building.id}
                                    building={building}
                                    handleClickDetail={handleClickDetail}
                                    isSkeleton={false} // Assuming you want to show actual buildings here
                                    isSlim
                                />
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );

}